import { createSelector } from '@reduxjs/toolkit';
import { selectDetails } from '../../store/selectors';

export const selectInvestmentService = createSelector(selectDetails, (details) => details.detail);
export const selectBenchmarks = createSelector(selectDetails, (details) => details.benchmarks);
